import Vue from 'vue';
import config from '@/config';
import store from '@/store';
import * as AuthService from '@/modules/authentication/services/authenticationService';

async function fetchSsoToken(ssoCode: string): Promise<void> {
  await AuthService.exchangeSsoCode(ssoCode)
    .then((res) => {
      const tokenData: AuthService.TokenResponse = res.data;
      if (tokenData.access_token !== undefined && tokenData.refresh_token) {
        store.dispatch('authentication/decodeAndUpdate', tokenData.access_token);
        Vue.$cookies.set(config.security.jwtRefreshCookie, tokenData.refresh_token);
      }
    })
    .finally(() => (window.location.hash = ''));
}

export { fetchSsoToken };
